  (function () {
    "use strict";

    angular.module("swurveys.maker")
        .factory('swurveyAdminService', Handler)

    //These are authenticated swurvey calls
    //

    function Handler($q, $timeout, swurveysStageConfig, analyticsService, utilsService) {

        var API_URI = swurveysStageConfig.getConfigPropertyValue("api_endpoint");
        var stage = API_URI.split("/").pop();

        var swurveysEndpoint = new AWS.Endpoint(API_URI);

        var swurveysClient = new AWS.Swurveys({
            endpoint: swurveysEndpoint,
            region: "us-east-1"
        });


        var iotdata = new AWS.IotData({endpoint: 'a3fh4kvqh2zv0s.iot.us-east-1.amazonaws.com',
            region: "us-east-1"
        });

        var s3 = new AWS.S3();

        var wrapCallback = function(callback) {
            return function (err, data) {
              $timeout(function(){
                callback(err, data)});
            };

        };

        var listSwurveys = function (userId, callback) {
            swurveysClient.listSwurveys({
                userId: userId
            }, wrapCallback(callback));
        };

        var listUsers = function (callback) {
            swurveysClient.listUsers(wrapCallback(callback));
        };

        var getUserStripe = function (userId, callback) {
            swurveysClient.getUserStripe({
                userId: userId
            }, wrapCallback(callback));
        };

        var getUser = function (userId, callback) {
            swurveysClient.getUser({
                userId: userId
            }, wrapCallback(callback));
        };

        var putModel = function (swurveyId, swurveyModel, callback) {
            swurveysClient.putSwurveyModel({
                swurveyId: swurveyId,
                swurveyModel: angular.toJson(swurveyModel),
                ContentType: "application/json"
            }, wrapCallback(callback));
        };

        var publishUserUpdate =function(userId, sessionId, swurveyId, subtopic, action, payload) {
            var topic = stage + "/users/" + userId + "/" + subtopic;
            var params = {
                topic: topic,
                payload: angular.toJson({ action : action, sessionId : sessionId, payload : payload, userId: userId, swurveyId: swurveyId}),
                qos: 0
            };

            iotdata.publish(params, function(err, data){
                if(err){
                    console.log(err);
                }
            });
        };


        var updateSwurveyState = function (swurveyId, state, callback) {
            swurveysClient.putSwurveyState({
                swurveyId: swurveyId,
                state: state
            }, wrapCallback(callback));
        };

        var createSwurvey = function (name, model, callback) {
            swurveysClient.createSwurvey({
                name: name
            }, wrapCallback(function (err, data) {
                    if(!err) {
                        model.name = name;
                        putModel(data.id, model, function (err, res) {
                            if(!err){
                            callback(null, data.id);
                            }
                            else {
                            console.log("Error: " + err);
                            callback(err);
                            }
                        });
                    }
                    else {
                      console.log("Error: " + err);
                      callback(err);
                    }
            }));
        };

        var getCSVLink = function (swurveyId, partition) {
            var params = {
                swurveyId: swurveyId
            };
            if(partition){
              params.partition = partition;
            }

            console.log(params);
            var req = swurveysClient.getSwurveyResponsesAsCSV(params);
            var url = req.presign();
            return url;
        };

        var getJSONLink = function (swurveyId) {
            var params = {
                swurveyId: swurveyId
            };
            var req = swurveysClient.getSwurveyResponses(params);
            var url = req.presign();
            return url;
        };

        var deleteSwurvey = function (swurveyId, callback) {
            var params = {
                swurveyId: swurveyId
            };
            swurveysClient.deleteSwurvey(params, wrapCallback(callback));
        };

        var updateUser = function (userId, params, callback) {
            params.userId = userId;
            swurveysClient.updateUser(params, wrapCallback(callback));
        };

        var updateSwurvey = function (swurveyId, params, callback) {
            params.SwurveyId = swurveyId;
            swurveysClient.updateSwurvey(params, wrapCallback(callback));
        };

        var login = function (userId, p, t) {

            swurveysClient.config.update({
                credentials: AWS.config.credentials
            });

            iotdata.config.update({
                credentials: AWS.config.credentials
            });

            s3.config.update({
                credentials: AWS.config.credentials
            });
            console.log("set credentials to ", AWS.config.credentials);

            var deferred = $q.defer();

            var referrer = utilsService.getQueryParameterByName("referrer");
            if(!referrer) {
                referrer = document.referrer;
            }

            var params = {
                userId: userId,
                provider: p,
                token: t,
                referrer: referrer

            };

            swurveysClient.login(params, function (err, data) {

                if(err) {
                    return deferred.reject(err);
                }

                analyticsService.setUserId(userId, data.user.email);

                if(data.user.loginCount == 1)
                {
                    //this means that this is the user's first login
                    analyticsService.trackEvent('CompleteRegistration');
                }

                //We always send a regular login event

                analyticsService.trackEvent('DesignerLogin');

                deferred.resolve(data);
            });

        return deferred.promise;
        };


        var addPaymentInstrument = function(userId, token, callback) {
            var params = {
                userId : userId,
                token : token
            };
            swurveysClient.addPaymentInstrument(params, wrapCallback(callback));
        };

        var purchaseCredits = function(userId, creditsToPurchase, callback) {
            var params = {
                userId : userId,
                creditsToPurchase : creditsToPurchase
            };
            swurveysClient.purchaseCredits(params, wrapCallback(callback));
        };

        var updatePaymentOptions = function(userId, options, callback) {
            var params = Object.assign({}, options);
            params.userId = userId;

            swurveysClient.postPaymentOptions(params, wrapCallback(callback));
        };

        var getReportURL = function (report, date) {

            var params = {
                date: date
            };
            var req = swurveysClient[report](params);
            var url = req.presign();
            return url;

        };


        var resetSwurveyData = function(swurveyId, callback)
        {
            var params = {
                swurveyId : swurveyId
            };
            swurveysClient.deleteSwurveyResponses(params, wrapCallback(callback));
        };

        return {
            login: login,
            listSwurveys: listSwurveys,
            listUsers: listUsers,
            putModel: putModel,
            getCSVLink: getCSVLink,
            getJSONLink: getJSONLink,
            deleteSwurvey: deleteSwurvey,
            createSwurvey: createSwurvey,
            updateSwurveyState: updateSwurveyState,
            getUserStripe: getUserStripe,
            getReportURL: getReportURL,
            addPaymentInstrument : addPaymentInstrument,
            purchaseCredits : purchaseCredits,
            updatePaymentOptions : updatePaymentOptions,
            getUser : getUser,
            updateUser : updateUser,
            updateSwurvey : updateSwurvey,
            publishUserUpdate : publishUserUpdate,
            resetSwurveyData : resetSwurveyData,
            s3 : s3
        };
    }
}());
